/**
 * Transforms the font size of list items in a given list to match the font size
 * of the first text-based child element, and adjusts list marker spacing.
 * 
 * @param {HTMLElement} list - The list element (either <ul> or <ol>) to transform.
 */
const transformListItems = (list) => {
    list.querySelectorAll('li').forEach((li, i) => {
        if (!(li instanceof Element)) {
            console.warn(`Skipping non-element at index ${i}:`, li);
            return;
        }
   
        if (window) {
            const firstItem = li.querySelector('& > *:not(input):not(span)');
            if (!(firstItem instanceof Element)) {
                console.warn(`Skipping invalid first child in <li> at index ${i}:`, firstItem);
                return;
            }

            const firstFontSize = window.getComputedStyle(firstItem).fontSize;
            if (firstFontSize) {
                li.style.fontSize = firstFontSize;
            }
        }
    });


};

/**
 * Prepares numbered lists by ensuring consistent font size for list items,
 * and adding responsiveness for window resize events.
 */
const prapareNumbedList = () => {
    const lists = document.querySelectorAll(`[data-type="numberedListBlocks"] ul, [data-type="numberedListBlocks"] ol`);

    console.log('Total lists found:', lists.length);

    if (lists.length) {
        let resizeTimeout;

        // Initial transformation for all lists
        for (let i = 0; i < lists.length; i++) {
            console.log(`Processing list ${i + 1}:`, lists[i]);
            transformListItems(lists[i]);   
        }

        // Add debounced resize event listener once
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                lists.forEach(list => {
                    transformListItems(list);
                });
            }, 300);
        });
    }
};

// Export the function as the default export
export default prapareNumbedList;
